import styles from './VNews.module.css'
import VTitle from '../../common/VTitle'
import { useDispatch } from 'react-redux';
import { memo, useEffect, useState } from 'react'
import DOMPurify from 'dompurify';

import arrow_right_small from "../../assets/img/icons/arrow_right_small.svg"
// Helmet
import { setNewThemeColor } from '../../../../features/helmet/helmetSlice';
// Modal
import useScrollBlock from '../../../../customHooks/useScrollBlock';
import VNewsModal from './VNewsModal';
import Modal_1 from '../../common/Modals/Modal_1';
// Truncate
import { truncateText } from '../../../../customHooks/truncateText';
// Media
import { useMedia } from "../../../../customHooks/useMedia"
// Данные новостей (единый источник)
import { news } from '../../../../data/news'

const Box = ({ data }) => {
  const [content, setContent] = useState('');
  useEffect( ()=>{
      setContent(DOMPurify.sanitize(data.content)); // Sanitize content
  }, [])

  const isLarge550 = useMedia('(min-width: 550px)');
  const isLarge450 = useMedia('(min-width: 450px)');

  const [blockScroll, allowScroll] = useScrollBlock();
  
  const dispatch = useDispatch();
  const changeThemeColor = (color) => dispatch(setNewThemeColor(color))

  const openNews = () => {
    // setTimeout(function(){}, 150);
    changeThemeColor({color: '#5c5d5e'})
    blockScroll()
    Modal_1.open(VNewsModal, {data});
  }

  return(
          <div className={styles.main_container}>
              <div className={"card__wrapper " + styles.card__wrapper}>
                  <div onClick={openNews} className={"card__content " + styles.card__content}>
                     

                                <div className={styles.header_date_btn_block}>
                                    <p className={styles.date}>{data.date}</p>
                                    <div className={styles.btn_more_container}>
                                        <button className={styles.btn_more}>Подробнее</button>
                                        <img src={arrow_right_small} alt='arrow right' />
                                    </div>
                                </div>
                                <div className={styles.content_container}>
                                    <h3 className={styles.title}>{data.title}</h3>
                                    <div>
                                        <img className={styles.news_icon} src={'assets/img/by_page/news/' + data.img_url_prev} alt='news pic' />
                                        <p className={styles.content} dangerouslySetInnerHTML={{ 
                                              __html: isLarge550 ? truncateText(content, 115) : isLarge450 ? truncateText(content, 100) : truncateText(content, 65) 
                                            }}
                                        />
                                    </div>  
                                </div>

                  </div>
              </div>
          </div>
  )
}

const VNews = () => {
  return (
    <>
      <div className={styles.page_wrapper}>
        <VTitle title="Новости" subtitle='Будьте в курсе самых последних обновлений Calipso' />
        <div className={styles.wrapper}>
            {news?.map( (item, k) => {
                return <Box key={k} data={item}  />
            })
            }
        </div>
      </div>
    </>
  )
}

export default memo(VNews)